import React, { useEffect, useState } from 'react';

const Hero = () => {
  const [showModal, setShowModal] = useState(false);
  const [result, setResult] = useState('');

  useEffect(() => {
    console.log('Hero section loaded');
  }, []);

  // Form submission handler
  const onSubmit = async (event) => {
    event.preventDefault();
    setResult('Sending...');
    const formData = new FormData(event.target);
    formData.append('access_key', '4b701ea6-eb3e-4c6a-a8d8-c13c4196b5de');
    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData
    });
    const data = await response.json();
    if (data.success) {
      setResult('Form Submitted Successfully');
      event.target.reset();
    } else {
      setResult('Error sending form. Please try again.');
    }
  };

  return (
    <section
      id="hero"
      className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 flex items-center justify-center text-center relative overflow-hidden pt-48"
    >
      {/* Decorative background elements */}
      <div className="absolute top-10 right-10 w-64 h-64 bg-gradient-to-br from-blue-200 to-purple-200 rounded-full opacity-20 blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-48 h-48 bg-gradient-to-br from-pink-200 to-blue-200 rounded-full opacity-20 blur-3xl"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10">
        {/* Main Heading */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6">
          <span className="text-blue-600">Transform Your Business</span>
          <br />
          <span className="text-transparent bg-gradient-to-r from-purple-500 to-pink-600 bg-clip-text">
            Into Success Story.
          </span>
        </h1>
        {/* Decorative underline */}
        <div className="flex justify-center mb-8">
          <div className="relative">
            <div className="h-1 w-32 bg-gradient-to-r from-purple-500 to-pink-600 rounded-full"></div>
            <div className="absolute -right-2 -top-1 w-3 h-3 bg-purple-600 rounded-full"></div>
          </div>
        </div>
        {/* Stats */}
        <div className="text-lg md:text-xl text-gray-700 mb-6 font-medium">
          3+ years | 200+ Brands | 25+ Crore Revenue Generated
        </div>
        {/* Description */}
        <p className="text-lg md:text-xl text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed">
          A passionate team of digital experts, creating exceptional growth strategies for our partners
          <br className="hidden md:block" />
          across the globe!
        </p>
        {/* CTA Button */}
        <button
          className="bg-gray-800 hover:bg-gray-900 text-white px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl"
          onClick={() => {
            setShowModal(true);
            setResult('');
          }}
        >
          Start Your Growth Journey
        </button>
        {/* Partners Section */}
        <div className="mt-20 mb-20">
          <p className="text-gray-600 font-medium mb-8">
            Our Digital Marketing Excellence is Recognized by
          </p>
          <div className="flex items-center justify-center space-x-8 md:space-x-12 flex-wrap gap-4">
            {/* Meta Business Partner */}
            <div className="flex items-center space-x-2 p-4 bg-white rounded-lg shadow-sm">
              <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center">
                <span className="text-white font-bold text-sm">M</span>
              </div>
              <div>
                <div className="font-bold text-gray-800 text-sm">Meta</div>
                <div className="text-xs text-gray-500">Business Partner</div>
              </div>
            </div>
            {/* Shopify Partners */}
            <div className="flex items-center space-x-2 p-4 bg-white rounded-lg shadow-sm">
              <div className="w-8 h-8 bg-green-600 rounded flex items-center justify-center">
                <span className="text-white font-bold text-sm">S</span>
              </div>
              <div>
                <div className="font-bold text-gray-800 text-sm">Shopify</div>
                <div className="text-xs text-gray-500">Partners</div>
              </div>
            </div>
            {/* Google Partner */}
            <div className="flex items-center space-x-2 p-4 bg-white rounded-lg shadow-sm">
              <div className="w-8 h-8 bg-red-500 rounded flex items-center justify-center">
                <span className="text-white font-bold text-sm">G</span>
              </div>
              <div>
                <div className="font-bold text-gray-800 text-sm">Google</div>
                <div className="text-xs text-gray-500">Partner</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Popup Form with required sections */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-2xl p-8 w-full max-w-md shadow-lg relative">
            <button
              className="absolute top-3 right-3 text-xl text-gray-500"
              onClick={() => setShowModal(false)}
            >
              &times;
            </button>
            <h2 className="text-2xl font-bold mb-3">Start Your Growth Journey</h2>
            <p className="mb-4 text-gray-600">
              We're here to answer any question you may have.
            </p>
            {/* Careers and Feedbacks section */}
            <div className="flex justify-between mb-6">
              <div>
                <span className="font-bold">careers</span>
                <br />
                <span>Would you like to join our growing team?</span>
                <br />
                <span className="font-bold text-indigo-600">hr@wetrnd.com</span>
              </div>
              <div>
                <span className="font-bold">Feedbacks</span>
                <br />
                <span>Have a project in mind?</span>
                <br />
                <span className="font-bold text-indigo-600">hi@wetrnd.com</span>
              </div>
            </div>
            {result === 'Form Submitted Successfully' ? (
              <div className="text-center">
                <h2 className="font-bold text-xl mb-4 text-green-600">Thank you!</h2>
                <p>Your submission has been sent. We will contact you soon.</p>
                <button
                  className="mt-4 text-blue-500 underline"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>
            ) : (
              <form onSubmit={onSubmit} className="flex flex-col gap-4">
                <input
                  type="text"
                  name="name"
                  placeholder="Your name?"
                  required
                  className="border rounded p-2"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email address?"
                  required
                  className="border rounded p-2"
                />
                <input
                  type="text"
                  name="phone"
                  placeholder="Your Phone Number?"
                  required
                  className="border rounded p-2"
                />
                <input
                  type="text"
                  name="budget"
                  placeholder="What's your budget?"
                  className="border rounded p-2"
                />
                <input
                  type="text"
                  name="website"
                  placeholder="Your Website?"
                  className="border rounded p-2"
                />
                <textarea
                  name="project"
                  placeholder="Tell us about your project"
                  required
                  className="border rounded p-2"
                  rows={3}
                />
                <button type="submit" className="bg-purple-600 text-white px-4 py-2 rounded mt-2">
                  SEND MESSAGE
                </button>
                <span className="text-center text-sm text-gray-500">{result}</span>
              </form>
            )}
            <div className="mt-4 text-center">
              <span className="bg-gray-100 px-4 py-1 rounded text-gray-600">wetrnd.com</span>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;
